var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 3.19995C8.9314 3.19995 3.2002 8.93115 3.2002 16C3.2002 18.4012 3.87469 20.64 5.0252 22.5604L3.31478 28.8L9.6877 27.127C11.5515 28.1867 13.7031 28.8 16.0002 28.8C23.069 28.8 28.8002 23.0688 28.8002 16C28.8002 8.93115 23.069 3.19995 16.0002 3.19995ZM11.6189 10.0291C11.8269 10.0291 12.0407 10.0279 12.2252 10.0375C12.4535 10.0428 12.7019 10.0595 12.9398 10.5854C13.2224 11.2104 13.8379 12.7785 13.9169 12.9375C13.9958 13.0964 14.0517 13.2836 13.9419 13.4916C13.8373 13.705 13.783 13.8341 13.6294 14.0229C13.4704 14.2063 13.2963 14.4342 13.1523 14.5729C12.9933 14.7318 12.8292 14.9061 13.0127 15.2229C13.1962 15.5397 13.8333 16.5782 14.7752 17.4166C15.9859 18.4982 17.0073 18.8306 17.3252 18.9895C17.6431 19.1485 17.8271 19.1237 18.0106 18.9104C18.1994 18.7024 18.8035 17.9887 19.0169 17.6708C19.2249 17.3529 19.4372 17.4079 19.7252 17.5125C20.0175 17.617 21.5761 18.3848 21.8939 18.5437C22.2118 18.7026 22.4202 18.7813 22.5002 18.9104C22.5823 19.0437 22.5824 19.6784 22.3189 20.4187C22.0555 21.1579 20.7617 21.8727 20.1814 21.9229C19.5958 21.9773 19.0493 22.1861 16.3752 21.1333C13.1496 19.8629 11.1154 16.5591 10.9564 16.3458C10.7975 16.1378 9.66478 14.6281 9.66478 13.0708C9.66478 11.5081 10.4841 10.7428 10.771 10.425C11.0633 10.1071 11.4056 10.0291 11.6189 10.0291Z",
    fill: "url(#paint0_linear_44_180)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_180",
    x1: 16.0002,
    y1: 3.19995,
    x2: 16.0002,
    y2: 28.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2784CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpp);
export default __webpack_public_path__ + "static/media/wpp.cd85641cab73cb43af64d82063098ad1.svg";
export { ForwardRef as ReactComponent };